exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flash[data-v-53108043] {\n&[data-v-53108043]:hover {\n        cursor: pointer;\n}\n\n    position: absolute;\n    z-index: 99999999;\n    left: 8px;\n    right: 8px;\n    bottom: 8px;\n    border: 1px solid black;\n.message[data-v-53108043] {\n        padding: 8px;\n}\n.icon.close[data-v-53108043] {\n        font-size: 1.5em;\n}\n}\n", ""]);

// exports
